import * as m from './authModels';

export const authInitialState: m.IAuthenticationContext = { isAuthenticated: false } as m.IAuthenticationContext;

export const authReducer = (state: m.IAuthenticationContext, action: m.ActionTypes): m.IAuthenticationContext => {
    switch (action.type) {
        case m.INIT_AZURE_SETTINGS:
            return {
                ...state,
                username: action.payload.username,
                roles: action.payload.roles,
                isAuthenticated: true
            };
        case m.INIT:
            return {
                ...state,
                assembly: action.payload.assembly,
                authType: action.payload.authType
            };
        default:
            return state;
    }
};
